import { CircularProgress } from "@mui/material";
import { useQuickStatsData } from "../../lib/hooks";
import { toShortNumber } from "../../lib/util";
import styles from "../../styles/analytics/analyticsPanel.module.css";
import QuickStatComponent from "./quickStatComponent";

export default function QuickViewCards() {
  const { loading, statsData } = useQuickStatsData();

  return (
    <div className={styles.quickStatContainer}>
      <div>
        <QuickStatComponent
          type="Fund"
          value={loading ? <CircularProgress /> : statsData?.no_of_funds}
          color="#9FCC2E"
        />
      </div>
      <div>
        <QuickStatComponent
          type="Challenges"
          value={loading ? <CircularProgress /> : statsData?.regular_challenges}
          color="#03A9F4"
        />
      </div>
      <div>
        <QuickStatComponent
          type="Proposals"
          value={
            loading ? (
              <CircularProgress />
            ) : (
              toShortNumber(statsData?.total_proposals, "comma")
            )
          }
          color="#AB47BC"
        />
      </div>
      <div>
        <QuickStatComponent
          type="Fund Budget"
          value={
            loading ? (
              <CircularProgress />
            ) : (
              `$${toShortNumber(statsData.fund_budget)}`
            )
          }
          color="#FA9F1B"
        />
      </div>
    </div>
  );
}
